<template>
  <div>
    <div class="handle_header">
      <el-card class="box-card">
        <div class="search">
          <el-form :inline="true">
            <el-form-item label="搜索">
              <el-input size="mini" v-model="option.name" placeholder="账户名称"></el-input>
              <el-input size="mini" v-model="option.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">查询</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="tableList">
      <el-button type="primary" size="mini" @click="derive">导出</el-button>
      <el-table :data="tableData" border style="width: 100%; margin-top: 10px"
        :row-style="{ 'font-size': '12px', color: '#324253' }"
        :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
        <el-table-column align="center" prop="name" label="账户名称"></el-table-column>
        <el-table-column align="center" prop="auth_count" label="认证次数"></el-table-column>
        <el-table-column align="center" prop="id_photo" label="身份证照片">
          <template slot-scope="scope">
            <div class="imags">
              <viewer :images="scope.row.id_photo.split('|')">
                <img :style="{ marginLeft: index == 1 ? '10px' : ''}" class="img" v-for="(src, index) in scope.row.id_photo.split('|')" :src="src" :key="index">
              </viewer>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号">
          <template slot-scope="scope">
            <span @click="displayPhone(scope)">{{ scope.row.real_phone || scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="id_video" label="人脸视频">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center;">
              <video class="video" controls>
                  <source :src="scope.row.id_video" type="video/mp4" />
              </video>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
        <el-table-column align="left" label="业务信息" min-width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.business_info">
              <span class="business-text">{{ truncateBusiness(scope.row.business_info) }}</span>
              <a v-if="isBusinessTruncated(scope.row.business_info)"
                href="javascript:;" class="more-link"
                @click="openBusinessView(scope.row)">更多</a>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="详细信息" width="260">
          <template slot-scope="scope">
            <a href="javascript:;" class="detail-link" :class="{ 'is-empty': !scope.row.business_info }"
              @click="openBusiness(scope.row)">业务信息</a>
            <a href="javascript:;" class="detail-link" :class="{ 'is-empty': !fileCount(scope.row, 'auth_file') }"
              @click="openFile(scope.row, 'auth_file')">授权信息<span v-if="fileCount(scope.row, 'auth_file')"> ({{ fileCount(scope.row, 'auth_file') }})</span></a>
            <a href="javascript:;" class="detail-link" :class="{ 'is-empty': !fileCount(scope.row, 'contract_file') }"
              @click="openFile(scope.row, 'contract_file')">合作合同<span v-if="fileCount(scope.row, 'contract_file')"> ({{ fileCount(scope.row, 'contract_file') }})</span></a>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <!-- <router-link :to="'/user/edit/' + scope.row.id">编辑</router-link> -->
            <a style="margin-left: 10px;" href="javascript:;" @click="editRow(scope, scope.row.id)">编辑</a>
            <a style="margin-left: 10px;" href="javascript:;" @click="deleteRow(scope, scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- 业务信息编辑弹窗 -->
      <el-dialog title="业务信息" :visible.sync="businessDialog.visible" width="600px" :close-on-click-modal="false">
        <el-input
          type="textarea"
          :rows="8"
          maxlength="2000"
          show-word-limit
          placeholder="请输入业务信息"
          v-model="businessDialog.text">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="businessDialog.visible = false">取消</el-button>
          <el-button size="mini" type="primary" :loading="businessDialog.saving" @click="saveBusiness">保存</el-button>
        </span>
      </el-dialog>

      <!-- 业务信息查看弹窗（只读） -->
      <el-dialog title="业务信息" :visible.sync="businessViewDialog.visible" width="600px">
        <div class="business-view">{{ businessViewDialog.text }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="businessViewDialog.visible = false">关闭</el-button>
          <el-button size="mini" type="primary" @click="editFromView">编辑</el-button>
        </span>
      </el-dialog>

      <!-- 授权信息 / 合作合同 上传弹窗（多文件） -->
      <el-dialog :title="fileDialog.field === 'auth_file' ? '授权信息' : '合作合同'"
        :visible.sync="fileDialog.visible" width="720px" :close-on-click-modal="false"
        v-loading="fileDialog.loading">
        <div v-if="fileDialog.urls.length === 0" class="file-empty">尚未上传文件</div>
        <viewer v-else :images="fileImages(fileDialog.urls)" class="file-list">
          <div v-for="(url, idx) in fileDialog.urls" :key="url" class="file-item">
            <div class="file-thumb">
              <img v-if="isImage(url)" :src="url" />
              <div v-else class="file-icon">PDF</div>
            </div>
            <div class="file-meta">
              <div class="file-name" :title="getFileName(url)">{{ idx + 1 }}. {{ getFileName(url) }}</div>
              <div class="file-actions">
                <a :href="url" target="_blank" rel="noopener">查看</a>
                <a :href="url" :download="getFileName(url)">下载</a>
                <a href="javascript:;" class="danger" @click.stop="deleteFile(url)">删除</a>
              </div>
            </div>
          </div>
        </viewer>

        <div class="upload-bar">
          <input ref="fileInput" type="file"
            accept=".png,.jpg,.jpeg,.gif,.bmp,.webp,.pdf,image/*,application/pdf"
            @change="onFileChange" />
          <p class="tip">
            支持 png / jpg / jpeg / gif / bmp / webp / pdf；建议不超过 10MB；多次上传会追加到列表。
          </p>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="fileDialog.visible = false">关闭</el-button>
          <el-button size="mini" type="primary" :loading="fileDialog.uploading"
            :disabled="!fileDialog.file" @click="uploadFile">上传</el-button>
        </span>
      </el-dialog>

      <el-pagination
        v-show="tableData.length > 0"
        style="display: flex;justify-content: flex-end;"
        background
        @current-change="handleCurrentChange"
        :current-page="option.pageNum"
        :page-size="option.pageSize"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";

export default {
  name: "userList",
  data() {
    return {
      total: 0,
      option: {
        name: '',
        phone: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      businessDialog: {
        visible: false,
        saving: false,
        row: null,
        text: '',
      },
      businessViewDialog: {
        visible: false,
        row: null,
        text: '',
      },
      businessPreviewLength: 100,
      fileDialog: {
        visible: false,
        loading: false,
        uploading: false,
        row: null,
        field: 'auth_file',
        urls: [],
        file: null,
      },
    };
  },
  methods: {
    isImage(url) {
      if (!url) return false;
      return /\.(png|jpe?g|gif|bmp|webp)(\?.*)?$/i.test(url);
    },
    truncateBusiness(text) {
      if (!text) return '';
      const limit = this.businessPreviewLength;
      const oneLine = String(text).replace(/\s+/g, ' ');
      return oneLine.length > limit ? oneLine.slice(0, limit) + '…' : oneLine;
    },
    isBusinessTruncated(text) {
      if (!text) return false;
      const oneLine = String(text).replace(/\s+/g, ' ');
      return oneLine.length > this.businessPreviewLength;
    },
    openBusinessView(row) {
      this.businessViewDialog.row = row;
      this.businessViewDialog.text = row.business_info || '';
      this.businessViewDialog.visible = true;
    },
    editFromView() {
      const row = this.businessViewDialog.row;
      this.businessViewDialog.visible = false;
      if (row) this.openBusiness(row);
    },
    verifyPassword(callback) {
      const password = prompt('请输入安全码');
      if (!password) return;
      this.$axios({
        url: '/check_pass',
        method: 'post',
        data: { password: password },
      }).then(res => {
        const data = res.data || {};
        if (data.code != 200) {
          alert(data.msg || '安全码错误');
          return;
        }
        callback();
      }).catch(() => {
        alert('安全码校验失败');
      });
    },
    openBusiness(row) {
      this.verifyPassword(() => {
        this.businessDialog.row = row;
        this.businessDialog.text = row.business_info || '';
        this.businessDialog.visible = true;
      });
    },
    saveBusiness() {
      const row = this.businessDialog.row;
      if (!row) return;
      this.businessDialog.saving = true;
      this.$axios({
        url: '/save_per_business',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data: { id: row.id, business_info: this.businessDialog.text },
      }).then(res => {
        const data = res.data || {};
        if (data.code !== 200) {
          alert(data.msg || '保存失败');
          return;
        }
        const newVal = data.business_info != null ? data.business_info : this.businessDialog.text;
        this.$set(row, 'business_info', newVal);
        if (this.businessViewDialog.row === row) {
          this.businessViewDialog.text = newVal;
        }
        this.businessDialog.visible = false;
        this.$notify.success({ title: '提示', message: '保存成功' });
      }).catch(() => {
        alert('保存失败');
      }).then(() => {
        this.businessDialog.saving = false;
      });
    },
    getFileList(row, field) {
      if (!row) return [];
      const list = row[field + '_list'];
      if (Array.isArray(list)) return list;
      const raw = row[field];
      if (!raw) return [];
      return String(raw).split('|').filter(Boolean);
    },
    fileCount(row, field) {
      return this.getFileList(row, field).length;
    },
    getFileName(url) {
      if (!url) return '';
      const seg = String(url).split('?')[0].split('/').pop() || '';
      return decodeURIComponent(seg);
    },
    fileImages(urls) {
      return (urls || []).filter(u => this.isImage(u));
    },
    syncRowFiles(row, field, urls) {
      this.$set(row, field + '_list', urls.slice());
      this.$set(row, field, urls.join('|'));
    },
    refreshDetail(row, field) {
      this.fileDialog.loading = true;
      return this.$axios({
        url: '/get_per_detail',
        method: 'get',
        params: { id: row.id },
      }).then(res => {
        const data = res.data || {};
        if (data.code !== 200) return;
        const detail = data.data || {};
        if (detail.business_info != null) this.$set(row, 'business_info', detail.business_info);
        ['auth_file', 'contract_file'].forEach(f => {
          const list = Array.isArray(detail[f + '_list']) ? detail[f + '_list'] :
            (detail[f] ? String(detail[f]).split('|').filter(Boolean) : []);
          this.syncRowFiles(row, f, list);
        });
        if (this.fileDialog.row === row && this.fileDialog.field === field) {
          this.fileDialog.urls = this.getFileList(row, field);
        }
      }).catch(() => {}).then(() => {
        this.fileDialog.loading = false;
      });
    },
    openFile(row, field) {
      this.verifyPassword(() => {
        this.fileDialog.row = row;
        this.fileDialog.field = field;
        this.fileDialog.urls = this.getFileList(row, field);
        this.fileDialog.file = null;
        this.fileDialog.visible = true;
        this.$nextTick(() => {
          if (this.$refs.fileInput) this.$refs.fileInput.value = '';
        });
        this.refreshDetail(row, field);
      });
    },
    onFileChange(e) {
      const files = e.target.files;
      this.fileDialog.file = files && files.length ? files[0] : null;
    },
    uploadFile() {
      const { row, field, file } = this.fileDialog;
      if (!row || !file) return;
      const allow = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'pdf'];
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (allow.indexOf(ext) === -1) {
        alert('仅支持图片或 PDF');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert('文件不能超过 10MB');
        return;
      }
      const form = new FormData();
      form.append('id', row.id);
      form.append('field', field);
      form.append('file', file);

      this.fileDialog.uploading = true;
      this.$axios({
        url: '/upload_per_file',
        method: 'post',
        data: form,
      }).then(res => {
        const data = res.data || {};
        if (data.code !== 200) {
          alert(data.msg || '上传失败');
          return;
        }
        const urls = Array.isArray(data.urls) ? data.urls :
          (data.url ? this.fileDialog.urls.concat([data.url]) : this.fileDialog.urls);
        this.syncRowFiles(row, field, urls);
        this.fileDialog.urls = urls.slice();
        this.fileDialog.file = null;
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
        this.$notify.success({ title: '提示', message: '上传成功' });
      }).catch(() => {
        alert('上传失败');
      }).then(() => {
        this.fileDialog.uploading = false;
      });
    },
    deleteFile(url) {
      const { row, field } = this.fileDialog;
      if (!row || !url) return;
      if (!confirm('确认删除该文件？删除后不可恢复。')) return;
      this.fileDialog.loading = true;
      this.$axios({
        url: '/delete_per_file',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data: { id: row.id, field: field, url: url },
      }).then(res => {
        const data = res.data || {};
        if (data.code !== 200) {
          alert(data.msg || '删除失败');
          return;
        }
        const urls = Array.isArray(data.urls) ? data.urls :
          this.fileDialog.urls.filter(u => u !== url);
        this.syncRowFiles(row, field, urls);
        this.fileDialog.urls = urls.slice();
        this.$notify.success({ title: '提示', message: '删除成功' });
      }).catch(() => {
        alert('删除失败');
      }).then(() => {
        this.fileDialog.loading = false;
      });
    },
    displayPhone(scope) {
      if (scope.row.real_phone) {
        return;
      }
      
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }

      this.$axios({
        url: '/query_mobile',
        method: 'post',
        data: { id: scope.row.id, source: 4, password: password }
      }).then(res => {
        return res.data;
      }).then(res => {
          console.log('查询结果', res);
           if (!res || res.code != 200) {
              alert('查询失败');
              return;
          }
          scope.row.real_phone = res.data;
      }).catch(function(){
          alert('查询失败');
      });
  
    },
    editRow(scope, id) {
      let that = this;
      console.log('编辑', id);
      var password = prompt('请输入安全码');
      if (!password) {
        return;
      }
      this.$axios({
        url: '/check_pass',
        method: 'post',
        data: {
          password: password,
        }
      }).then(res => {
        res = res.data;
        console.log('编辑结果', res);
        if (!res || res.code != 200) {
          alert(res.msg || '编辑失败');
          return;
        }
        that.$router.push('/user/edit/' + id)
      }).catch(function(){
      });
    },
    deleteRow(scope, id) {
      console.log('删除', id);
      var password = prompt('请输入安全码');
      if (!password) {
        return;
      }
      this.$axios({
        url: '/delete_user',
        method: 'post',
        data: {
          id: id,
          password: password,
        }
      }).then(res => {
        res = res.data;
        console.log('删除结果', res);
        if (!res || res.code != 200) {
          alert(res.msg || '删除失败');
          return;
        }
        this.tableData.splice(scope.$index, 1);
        alert('删除成功');
      }).catch(function(){
          alert('删除失败');
      });
    },
    derive(){
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }
      this.$axios({
        url: '/download_xls',
        method: 'get',
        responseType: "blob",//重要配置
        params: {type: '个人认证', password: password,}
      }).then(res => {
        if (res.data.type == 'application/json') {
            alert('导出失败');
            return;
        }
        const aLink = document.createElement("a");
        let blob = new Blob([res.data])
        aLink.href = URL.createObjectURL(blob)
        aLink.setAttribute('download', '个人认证.xlsx') // 设置下载文件名称
        aLink.click()
      })
    },
    getList() {
      this.tableData = [];
  
      this.$axios({
        url: '/list_per_data',
        method: 'get',
        params: this.option
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(val, currentPage) {
      this.option.pageNum = val;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.option.name = '';
      this.option.phone = '';
      this.option.pageNum = 1;
      this.option.pageSize = 10;
      this.getList();
    },
  },
  activated() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.page {
  text-align: right;
}

.imags {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  width: 80px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
.video{
  width: 80px;
  height: 80px;
  // object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
.file-empty {
  padding: 24px 0;
  text-align: center;
  color: #909399;
}
.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 4px;
}
.file-item {
  width: 200px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}
.file-thumb {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  overflow: hidden;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    cursor: pointer;
  }
  .file-icon {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #e74c3c;
    color: #fff;
    font-weight: bold;
    border-radius: 4px;
    letter-spacing: 1px;
  }
}
.file-meta {
  padding: 6px 8px;
  .file-name {
    font-size: 12px;
    color: #324253;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }
  .file-actions {
    display: flex;
    gap: 10px;
    font-size: 12px;
    a {
      color: #409EFF;
      text-decoration: none;
      &:hover { text-decoration: underline; }
      &.danger { color: #f56c6c; }
    }
  }
}
.upload-bar {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #ebeef5;
  .tip {
    font-size: 12px;
    color: #8994A1;
    margin-top: 6px;
  }
}
.detail-link {
  display: block;
  margin: 4px 0;
  color: #409EFF;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &.is-empty {
    color: #f56c6c;
  }
}
.business-text {
  color: #324253;
  word-break: break-all;
}
.more-link {
  margin-left: 6px;
  color: #409EFF;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.business-view {
  max-height: 400px;
  overflow-y: auto;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
  color: #324253;
  line-height: 1.6;
}
</style>